<template>
  <div data-v-9dfc9050="" data-v-2ac6a5fc="" class="login">
    <div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <div style="width: 98vw; border-radius: 8px">
            <img :src="item.src" style="width: 100%; height: auto; border-radius: 8px" />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div data-v-9dfc9050="" class="login-content">
      <div>
        <van-tabs @change="tabChange" v-model="loginInfo.type" color="#cca352" title-active-color="#cca352" title-inactive-color="#6a6a73" background="#1b1b1b" style="margin-bottom: 10px">
          <van-tab v-for="(item, index) in loginType" :key="index" :title="item.title" :name="item.key"> </van-tab>
        </van-tabs>
      </div>
      <div data-v-9dfc9050="" class="login-form">
        <div data-v-9dfc9050="" class="login-group">
          <label data-v-9dfc9050="">{{ loginInfo.type == 2 ? '手机号':'账号' }}</label>
          <div data-v-9dfc9050="" class="login-input">
            <input data-v-9dfc9050="" v-model="loginInfo.name" id="loginName" autocomplete="off" maxlength="13" type="text" class="inpt username" />
            <div data-v-75833532="" data-v-9dfc9050="" class="count-down" style="display: none">
              <div data-v-75833532="" class="send">获取验证码</div>
            </div>
          </div>
        </div>
        <div data-v-9dfc9050="" class="login-group verifyWarp" v-show="loginInfo.type == 1">
          <label data-v-9dfc9050=""> 密码 </label>
          <div data-v-9dfc9050="" class="login-input">
            <input data-v-9dfc9050="" v-model="loginInfo.password" autocomplete="off" maxlength="16" type="password" class="inpt" />
          </div>
        </div>
        <div data-v-9dfc9050="" class="login-group verifyWarp" v-show="loginInfo.type == 1">
          <label data-v-9dfc9050=""> 验证码 </label>
          <div data-v-9dfc9050="" class="login-input" style="display: flex">
            <input data-v-9dfc9050="" v-model="loginInfo.auth_code" autocomplete="off" maxlength="6" type="text" class="inpt" />
            <div style="cursor: pointer; height: 37px" @click="changIndex" id="yzm_box"></div>
          </div>
        </div>
        <div data-v-9dfc9050="" class="login-group verifyWarp" v-show="loginInfo.type == 2">
          <label data-v-9dfc9050=""> 验证码 </label>
          <div data-v-9dfc9050="" class="login-input" style="display: flex">
            <input data-v-9dfc9050="" v-model="loginInfo.auth_code" autocomplete="off" maxlength="6" type="text" class="inpt" />
            <div style="cursor: pointer; height: 37px; width: 180px; line-height: 37px; text-align: center">
              <a v-if="num <= 0" @click="sendCode" href="javascript:void(0);" style="color: #fff; background-image: linear-gradient(224deg, #ffdf91, #ffcb4c); color: #482000; padding: 5px 8px; border-radius: 3px">发送验证码</a>
              <span v-else>{{ num }} 秒后重新发送</span>
            </div>
          </div>
        </div>
        <p data-v-9dfc9050="" class="forgetpassword">
          <a @click="$parent.openKefu()" style="color: #999"><span data-v-9dfc9050="">忘记账号／密码？</span></a>
        </p>
      </div>
      <div data-v-9dfc9050="" class="form-btn loginBtn" @click="login" style="border-radius: 30px">登录</div>
      <div data-v-9dfc9050="" class="form-btn loginBtn" @click="$parent.goNav('/register')" style="border-radius: 30px; background-color: #141414; border: 1px solid #cca352; color: #cca352">还未创建账户? 点击注册</div>
      <div style="width: 70%; margin: 20px auto 0; text-align: center">
        <van-row>
          <van-col :span="12" style="border-right: 1px solid #666">
            <div style="font-size: 16px; height: 25px; line-height: 25px; display: inline-flex" @click="$parent.goNav('/')">
              <van-icon name="home-o" size="24" style="margin-top: 0px" />
              <div style="margin-top: 0px">先去逛逛</div>
            </div>
          </van-col>
          <van-col :span="12">
            <div style="font-size: 16px; height: 25px; line-height: 25px; display: inline-flex" @click="$parent.goNav('/myNews')">
              <van-icon name="service-o" size="24" />
              <span>在线客服</span>
            </div>
          </van-col>
        </van-row>
      </div>
      <p data-v-9dfc9050="" class="notes">{{ $store.state.appInfo.title }}支持数字币存取 <span data-v-9dfc9050="">安全•便捷•秒到账</span></p>
    </div>

    <div data-v-15ef9544="" data-v-9dfc9050="" class="dialog"></div>
    <div data-v-15ef9544="" data-v-9dfc9050="" class="dialog"></div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data () {
    return {
      loginInfo: {
         type: '1',
        name: '',
        password: '',
        auth_code: null,
      },
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      codetmp: null,
      bannerList: null,
      loginType: [
        { title: '账号登录', key: '1' },
        { title: '手机号登录', key: '2' },
      ],
      num: 0,
      timer: null,
    };
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer);
  },
  created () {
    let that = this;
    that.imgLis = [];
    this.$nextTick(() => {
      document.getElementById('yzm_box').innerHTML = '';
      const { code, canvas } = that.createAdvancedCode();
      that.codetmp = code;
      document.getElementById('yzm_box').appendChild(canvas);
    });
    that.getBanList();
  },
  methods: {
    tabChange(){
      this.loginInfo.name = null
      this.loginInfo.auth_code = null
      this.loginInfo.password = null
      this.changIndex()
    },
    sendCode () {
      let phonereg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-9])|(?:5[0-3,5-9])|(?:6[5-6])|(?:7[0-8])|(?:8[\d])|(?:9[1,8-9]))\d{8}$/;
      const name = this.loginInfo.name || '';
      if (phonereg.test(name) == false) {
        this.$parent.showTost(0, ' 请输入正确的手机号！');
        return;
      }

      this.$parent.showLoading();
      this.$apiFun
        .get('/api/registerNote', { mobile: name })
        .then(res => {
          this.$parent.showTost(1, res.message);
          if (res.code == 200) {
            this.num = 60;
            const that = this;
            this.$nextTick(() => {
              that.timer = setInterval(() => {
                if (that.num >= 0) that.num -= 1;
                else {
                  that.num = 0;
                  if (that.timer) clearInterval(that.timer);
                }
              }, 1000);
            });
          }
          this.$parent.hideLoading();
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
    createAdvancedCode () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 120;
      canvas.height = 37;

      // 生成背景色
      ctx.fillStyle = `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 生成验证码
      let code = '';
      for (let i = 0; i < 4; i++) {
        const num = Math.floor(Math.random() * 10);
        code += num;
        ctx.font = 'bold 24px Arial';
        ctx.fillStyle = `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`;
        ctx.fillText(num, 20 + i * 25, 30);
      }

      // 添加干扰线
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgba(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255},0.7)`;
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }

      return { code, canvas };
    },
    changIndex () {
      const that = this;
      this.$nextTick(() => {
        document.getElementById('yzm_box').innerHTML = '';
        const { code, canvas } = that.createAdvancedCode();
        that.codetmp = code;
        document.getElementById('yzm_box').appendChild(canvas);
      });
    },
    login () {
      let that = this;
      let info = that.loginInfo;
      if (this.loginInfo.type != 2) {
        if (!info.name || !info.password) {
          that.$parent.showTost(0, '请输入您的账号和密码！');
          return;
        }
        let code = that.loginInfo.auth_code;
        if (!code) {
          that.$parent.showTost(0, '请输入验证码！');

          return;
        }
        if (code.toUpperCase() != that.codetmp) {
          that.$parent.showTost(0, '验证码错误！');
          that.loginInfo.code = null;
          that.changIndex();
          return;
        }
      } else {
        let phonereg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-9])|(?:5[0-3,5-9])|(?:6[5-6])|(?:7[0-8])|(?:8[\d])|(?:9[1,8-9]))\d{8}$/;
        const name = this.loginInfo.name || '';
        if (phonereg.test(name) == false) {
          this.$parent.showTost(0, ' 请输入正确的手机号！');
          return;
        }
        let code = that.loginInfo.auth_code;
        if (!code) {
          that.$parent.showTost(0, '请输入验证码！');

          return;
        }
      }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.loginInfo.code = null;
          that.changIndex();
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
        }
      });
    },
    mounted () {
      let that = this;
    },
    getBanList () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2, show_type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/main/login.vue